<template>
	<layout-page title="My Lots">
		<crop-filter
			v-model="filter"
			v-if="showFilter"
			v-on:close="closeFilter()"
			:show-city="false"
			:show-city-options="true"
			:all-city-options="allCityOptions"
		/>

		<div class="flex-grow flex flex-col">
			<!-- header -->
			<div
				class="bg-green px-4 sm:px-6 py-4 md:rounded-tl-2xl lg:rounded-tl-2xl xl:rounded-t-2xl flex justify-start items-center"
			>
				<h1 class="text-2xl md:text-4xl font-semibold text-white">
					{{ __("My Lots") }}
				</h1>
			</div>

			<!-- filter bar -->
			<div
				class="px-4 sm:px-6 lg:px-6 py-4 bg-gray-700 flex-wrap flex justify-between items-center md:space-x-6"
			>
				<button
					class="relative inline-flex items-center px-2 lg:pr-4 py-1.5 font-medium text-white bg-gray-500 hover:bg-gray-400 rounded-lg flex items-center focus:ring-2 ring-gray-400"
					v-on:click="showFilter = !showFilter"
				>
					<ui-icon
						class="mr-2 flex-shrink-0 h-5 w-5"
						name="filter"
						stroke-width="2"
					/>
					{{ __("Filter") }}
					<span
						class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-or-50 transform translate-x-1/4 -translate-y-1/2 bg-orange rounded-full"
						v-if="activeFilterCount > 0"
						>{{ activeFilterCount }}</span
					>
				</button>

				<div class="flex items-center space-x-4 text-gray-100">
					<div class="flex items-center">
						<input
							id="angebote"
							name="angebote"
							type="checkbox"
							v-model="filter.type.BUY"
							checked="checked"
							class="h-5 w-5 bg-gray-600 border-gray-300 rounded text-orange focus:ring-orange hover:ring-4 hover:ring-orange-800 cursor-pointer"
						/>
						<label
							for="angebote"
							class="pl-3 block font-medium whitespace-nowrap cursor-pointer"
							>{{ __("Buy Offers") }}</label
						>
					</div>
					<div class="flex items-center cursor-pointer">
						<input
							id="nachfrage"
							name="nachfrage"
							type="checkbox"
							v-model="filter.type.SELL"
							checked="checked"
							class="h-5 w-5 bg-gray-600 border-gray-300 rounded text-orange focus:ring-orange border-gray-200 rounded hover:ring-4 hover:ring-orange-800 cursor-pointer"
						/>
						<label
							for="nachfrage"
							class="pl-3 block font-medium whitespace-nowrap cursor-pointer"
							>{{ __("Sell Offers") }}</label
						>
					</div>
				</div>

				<p
					class="text-gray-100 font-medium hidden lg:block"
					v-if="offers.length"
				>
					<span class="hidden xl:inline">{{ __("Showing results") }}</span>
					{{
						__("messages.results_of_total", {
							args: {
								results: filteredOffers.length,
								total: offers.length,
							},
						})
					}}
					<span class="" v-if="locale == 'de'">Inseraten</span>
					<span v-else>listings</span>
				</p>

				<!-- <span class="" v-if="viewType == 'edit'">
                    <ui-button label="Save" v-on:click="$refs.editView.submit()">
                    </ui-button>
                </span> -->

				<!-- hover:ring-2 hover:ring-gray-600 -->
				<span
					class="hidden md:block relative z-0 inline-flex bg-gray-600 rounded-lg p-0.5"
				>
					<page-link
						:href="$route('offer_all.bulkEdit')"
						class="inline-block relative px-4 py-1 rounded-md font-medium"
						:class="[
							viewType == 'edit'
								? 'bg-gray-500 text-white'
								: 'hover:bg-gray-500 text-gray-100 cursor-pointer',
						]"
						:absolute="true"
						>{{ __("Edit View") }}</page-link
					>
					<page-link
						:href="$route('offer_all.index')"
						class="inline-block relative px-4 py-1 rounded-md font-medium"
						:class="[
							viewType == 'list'
								? 'bg-gray-500 text-white'
								: 'hover:bg-gray-500 text-gray-100 cursor-pointer',
						]"
						:absolute="true"
						>{{ __("List View") }}</page-link
					>
				</span>
			</div>

			<content-my-lots-empty-farmer
				v-if="offers.length == 0 && user.type == 'FARMER'"
			/>
			<content-my-lots-empty v-else-if="offers.length == 0" />
			<content-my-lots-no-matches v-else-if="filteredOffers.length == 0" />
			<my-lots-list
				:filteredOffers="filteredOffers"
				:activeFutures="activeFutures"
				:auction="auction"
				:auctionMyLotsState="auctionMyLotsState"
				:piEndOfDay="piEndOfDay"
				:piShowButton="piShowButton"
				v-else-if="viewType == 'list'"
			/>
			<my-lots-edit
				:filteredOffers="filteredOffers"
				:activeFutures="activeFutures"
				:inactiveFutures="inactiveFutures"
				v-else-if="viewType == 'edit'"
				:key="filteredOffers.length"
				:auctionMyLotsState="auctionMyLotsState"
				ref="editView"
				class="flex-grow"
			/>
		</div>
	</layout-page>
</template>

<script>
import Vue from "vue";
import { uniq } from "lodash";
import UiFilterSessionStorage from "../components/Ui/FilterSessionStorage.vue";

export default {
	mixins: [UiFilterSessionStorage],
	props: {
		offers: {
			type: Array,
			required: true,
		},
		viewType: {
			type: String,
			default: "list",
		},
		activeFutures: {
			type: Array,
			default: () => [],
		},
		inactiveFutures: {
			type: Array,
			default: () => [],
		},
		auction: {
			type: Object,
			required: false,
			default: null,
		},
		auctionMyLotsState: {
			type: String,
			required: false,
			default: "DISABLED",
		},
		piEndOfDay: {
			type: Boolean,
			required: false,
			default: false,
		},
		piShowButton: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			filter: Vue.observable({
				productGrades: [],
				productYears: [],
				type: {
					BUY: true,
					SELL: true,
				},
				dateType: [],
				monthType: {
					month_from: null,
					month_to: null,
				},
				locationModes: [],
				locationAddressCity: [],
				locationAddressCityOptions: [],
			}),
			showFilter: false,
			user: this.$inertia.page.props.user,
		};
	},
	methods: {
		closeFilter() {
			this.showFilter = false;
		},
		intervalCheck(month_from, month_to) {
			let selectedMonthFrom = this.filter.monthType.month_from,
				selectedMonthTo = this.filter.monthType.month_to,
				leftCheck =
					selectedMonthFrom == null ||
					month_from == null ||
					month_from >= selectedMonthFrom,
				rightCheck = selectedMonthTo == null || selectedMonthTo >= month_to;
			return leftCheck && rightCheck;
		},
		updateData() {
			this.$inertia.reload({ preserveState: true, preserveScroll: true });
		},
	},
	created() {
		/*if (this.hasPendingPriceIndications) {
			console.log("setting up polling for changes");
			this.interval = setInterval(
				function () {
					this.updateData();
				}.bind(this),
				5000
			);
		}*/
	},
	beforeDestroy() {
		clearInterval(this.interval); // this is important!
	},
	computed: {
		hasPendingPriceIndications() {
			const hasPending = (this.offers || []).reduce(function (accum, offer) {
				if (["PENDING", "INPROGRESS"].includes(offer.priceindication?.status)) {
					return true;
				}
				return accum;
			}, false);
			return hasPending;
		},
		activeFilterCount() {
			return Object.values(this.filter).flat().length - 2;
		},
		filteredOffers() {
			let //mine = this.filterOptions['mine'],
				//selectedHubs = this.getSelectedIds(this.filterOptions['location__hub']),
				selectedTypes = this.filter.type,
				selectedGrades = this.filter.productGrades,
				selectedHarvests = this.filter.productYears,
				selectedDates = this.filter.dateType,
				selectedLocationModes = this.filter.locationModes,
				selectedLocationCityOptions = this.filter.locationAddressCityOptions;
			return (
				this.offers
					//.filter(offer => mine ? offer.mine : true)
					.filter(
						(offer) =>
							selectedLocationModes.length == 0 ||
							selectedLocationModes.includes(offer.location.mode)
					)
					.filter(
						(offer) =>
							selectedLocationCityOptions.length == 0 ||
							selectedLocationCityOptions.includes(offer.location.address?.city)
					)
					.filter(
						(offer) =>
							selectedGrades.length == 0 ||
							(!offer.product.grade.includes("WHEAT_B") &&
								selectedGrades.includes(offer.product.grade)) ||
							(offer.product.grade.includes("WHEAT_B") &&
								selectedGrades.includes("WHEAT_B"))
					)
					.filter(
						(offer) =>
							selectedHarvests.length == 0 ||
							selectedHarvests.includes(offer.product.harvest)
					)
					.filter(
						(offer) =>
							selectedDates.length == 0 ||
							(selectedDates.includes("AT_HARVEST") &&
								offer.date.type == "AT_HARVEST") ||
							(selectedDates.includes("MONTH") &&
								offer.date.type != "AT_HARVEST" &&
								this.intervalCheck(offer.date.month_from, offer.date.month_to))
					)
					.filter((offer) => selectedTypes[offer.trade] == true)
			);
		},
		filteredOffersBuy() {
			return this.filteredOffers.filter((o) => o.trade == "BUY");
		},
		filteredOffersSell() {
			return this.filteredOffers.filter((o) => o.trade == "SELL");
		},
		allCityOptions() {
			let allCities = this.offers
				.map((o) => o.location.address.city ?? null)
				.filter((o) => o != null);
			return uniq(allCities);
		},
	},
};
</script>
